export const DISABILITY_OPTIONS = [
  { value: 'VISION', label: '视力残疾' },
  { value: 'HEARING', label: '听力残疾' },
  { value: 'SPEECH', label: '言语残疾' },
  { value: 'PHYSICAL', label: '肢体残疾' },
  { value: 'INTELLECTUAL', label: '智力残疾' },
  { value: 'MENTAL', label: '精神残疾' },
  { value: 'MULTIPLE', label: '多重残疾' },
  { value: 'OTHER', label: '其他残疾' }
];

export const SERVICE_OPTIONS = [
  { value: 'MEDICAL_OXYGEN', label: '供航空器上使用的医用氧气' },
  { value: 'ELECTRIC_WHEELCHAIR', label: '托运电动轮椅' },
  { value: 'ONBOARD_WHEELCHAIR', label: '提供机上专用窄型轮椅' },
  { value: 'DISABLED_GROUP', label: '残疾人团体乘机服务' },
  { value: 'SERVICE_DOG', label: '携带服务犬进入客舱' },
  { value: 'OTHER', label: '其他' }
];
